import './App.css';
import RootNavigation from './navigation/RootNavigation';

function App() {

  return (<RootNavigation />);
}

export default App;
